/** "Pick from past" — one select above a Title / Dispo field group that fills
 * every field of the group from a contact you've used before (Tom 2026-08-31).
 * Shared by the lead drawer and the deal's Purchasing tab. */
import { pastContactLabel, type PastContact } from "./pastContacts";

export function PastContactPicker({ options, kind, onPick }: {
  options: PastContact[];
  kind: "title" | "dispo";
  onPick: (c: PastContact) => void;
}) {
  if (!options.length) return null;
  return (
    <div className="pastpick">
      <select
        className="moneyinput pastpicksel"
        value=""
        title={"Fill from a " + (kind === "title" ? "title company" : "dispo contact") + " you've used before"}
        onChange={(e) => {
          const i = parseInt(e.target.value, 10);
          const c = options[i];
          if (c) onPick(c);
        }}
      >
        <option value="">{kind === "title" ? "Pick a past title company…" : "Pick a past dispo contact…"}</option>
        {options.map((c, i) => (
          <option key={i} value={String(i)}>{pastContactLabel(c)}</option>
        ))}
      </select>
    </div>
  );
}
